import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import ElementTitle from '../../../../components/title/elementTitle/elementTitle';
import CustomisedCardDivider from '../../../../components/card/cardDivider';
import { NumberDisplay } from '../../../../components/numberDisplay/numberDisplay';
import CustomisedTextField from '../../../../components/textField/textField';
import CustomisedButton from '../../../../components/button/button';
import ChequeRegisterSkeleton from './chequeRegisterSkeleton';
import {
    GetCheques,
    UpdateCheque,
    ValidateCheque,
} from '../../../../services/cheque.service';
import { useMutation } from 'react-query';
import {
    ICheqeuResponse,
    IGetCheqeuRequest,
    IUpdateCheque,
    IValidationChequeResponse,
} from '../../../../models/cheque.model';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import CustomisedErrorCard from '../../../../components/card/errorCard';
import CustomisedCardUpload from '../../../../components/card/cardUpload';
import CustomisedCardLoad from '../../../../components/card/cardLoad';
import { IUploadFile } from '../../../../models/uploadFile.model';
import { IDocument } from '../../../../models/common.model';
import { IContainerApp } from '../../../navigationButtonComponents/loansTab/containerApp/IContainerApp';
import { IInnerStateCheque } from '../IInnerstate';
import { changeRouteType, getNextInnerState, getpervInnerState } from '../../../../redux/handleBackBtn/handleBackBtnSlice';
import { useAppBar } from '../../../../components/appBar/appBarContext';
import { DOCUMENT_TYPES } from '../../../../config/cacheKey';
import { IDocumentTypeHints } from '../../../../models/basicInformation.model';
import ChequeGuide from '../../../../components/chequeGuide/chequeGuide';

export default function ChequeRegister({ setStep, setInnerState, referenceKey }: IInnerStateCheque) {
    const empthyFileArray = {} as IDocument;
    const [sayadNumber, setSayadNumber] = useState<string>('');
    const [validationIssues, setValidationIssues] = useState<string[]>([]);
    const [frontImage, setFrontImage] = useState<any>(empthyFileArray);
    const [rearImage, setRearImage] = useState<any>(empthyFileArray);
    const [chequeData, setChequeData] = useState<ICheqeuResponse>();
    const dispatch = useDispatch();
    const { setHeader } = useAppBar();
    const documentType = JSON.parse(localStorage.getItem(DOCUMENT_TYPES)!);
    const frontImg = documentType.filter((item: IDocumentTypeHints) => item.documentType === 'FrontInstallmentCheque');
    const rearImg = documentType.filter((item: IDocumentTypeHints) => item.documentType === 'RearInstallmentCheque');
    const randomKeyForDispatch = Math.random();
    const getNumber = (e: any) => {
        setSayadNumber(e.target.value);
    };
    const sayadNumberNumberCodeHandleKeyDown = (event: any) => {
        var key = event.keyCode ? event.keyCode : event.which;
        if (!/[0-9]/.test(event.key) && key != 8 && key != 46) {
            event.preventDefault();
        }
    };
    const chequeId = useSelector(
        (state: RootState) => state.chequeInfo.chequeId
    );
    const chequeType = useSelector(
        (state: RootState) => state.chequeInfo.chequeType
    );
    const { mutateAsync: getChequeMutation, isLoading } = useMutation(
        GetCheques,
        {
            onSuccess: (data: ICheqeuResponse[]) => {
                if (data) {
                    setChequeData(data[0]!);
                    setSayadNumber(data[0]!.sayadNumber);
                    setFrontImage(data[0]!.frontImage);
                    setRearImage(data[0]!.rearImage);
                }
            },

            onError: (err) => {
                console.log(err);
            },
        }
    );

    const { mutateAsync: UpdateChequeMutation, isLoading: UpdateChequeLoding } =
        useMutation(UpdateCheque, {
            onSuccess: (data: ICheqeuResponse) => {
                if (data.isValid) {

                    setInnerState!('chequeList');
                }
                if (data.isValid === false) {
                    setValidationIssues(data.validationIssues);
                }
            },

            onError: (err) => {
                console.log(err);
            },
        });
    useEffect(() => {
        setHeader('ثبت چک های اقساط و ضمانت', 'cheque');
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: `chequeList ${randomKeyForDispatch}` }));
    }, [])
    useEffect(() => {
        const request = {} as IGetCheqeuRequest;
        request.referenceKey = referenceKey!;
        request.chequeType = chequeType;
        request.chequeId = chequeId;
        getChequeMutation(request);
    }, [chequeId]);
    const handleCheque = async () => {
        const request = {} as IUpdateCheque;
        request.referenceKey = referenceKey!;
        request.sayadNumber = sayadNumber;
        request.chequeId = chequeId;
        request.frontImage = frontImage ? frontImage.file
            ? frontImage.file
            : await fileURLToFile(`${frontImage.fileUrl}/true`, "myImage.jpg", frontImage) : null;
        request.rearImage = rearImage ? rearImage?.file
            ? rearImage?.file
            : await fileURLToFile(`${rearImage.fileUrl}/true`, "myRearImage.jpg", rearImage) : null;


        UpdateChequeMutation(request);

    };
    const functionCheque = () => {
        setRearImage(null)

    }
    const functionChequeFront = () => {
        setFrontImage(null)

    }
    async function fileURLToFile(fileUrl: any, fileName: any, originalFile: any) {
        const response = await fetch(fileUrl);
        // const blob = await response.blob();
        // const arrayBuffer = await response.arrayBuffer();
        // const blob = new Blob([arrayBuffer], { type: response.headers.get("Content-Type") || "image/png" });
        const blob = await response.blob();
        const file: any = new File([blob], fileName, { type: response.headers.get("Content-Type")! });
        file.preview = URL.createObjectURL(blob);
        //form.append("blob", blob, filename);
        // file.path = fileUrl;


        return file;
    }
    if (isLoading) {
        return <ChequeRegisterSkeleton />;
    }
    return (
        <div className="container-height-drawer">
            <div className=" primaryColorLight-900 content-container">
                {chequeData && (
                    <>
                        <div style={{ marginBottom: '20px !important' }} className='drawer-content'>
                            <div>
                                <ChequeGuide
                                    dueDatePersian={chequeData?.dueDatePersian!}
                                    dueDateAlphabet={chequeData?.dueDateAlphabet!}
                                    amount={chequeData?.amount!}
                                    amountAlphabet={chequeData?.amountAlphabet!}
                                    expectedHolder={chequeData?.expectedHolder!}
                                    expectedIdCode={chequeData?.expectedIdCode!}
                                    reasonTitle={chequeData!.reasonTitle}
                                />
                            </div>
                            <div className="mt-6">
                                <ElementTitle title="ثبت چک صیادی و استعلام" />
                            </div>
                            {validationIssues?.length > 0 && (
                                <div className="mt-3">
                                    <CustomisedErrorCard titleList={validationIssues} />
                                </div>
                            )}

                            <div className="!mt-5">
                                <CustomisedTextField
                                    helperText={''}
                                    error={false}
                                    label=" شماره صیادی"
                                    placeholder={'1234567891234567'}
                                    required={true}
                                    inputProps={{ type: 'tel', maxLength: 16, inputMode: 'numeric', lang: 'en' }}
                                    value={sayadNumber}
                                    onChange={getNumber}
                                    name="sayadNumber"
                                    id="sayadNumber"
                                    onKeyDown={sayadNumberNumberCodeHandleKeyDown}
                                />
                            </div>
                            <Typography className="!mt-8 ">
                                در صورتی که چک شما{' '}
                                <b className="text-[#BBA57A]">دیجیتال</b>{' '}
                                میباشد، نیاز به بارگذاری تصویر رو و پشت چک نمیباشد
                            </Typography>

                            <div className="mt-8">
                                {frontImage?.fileUrl ? (
                                    <CustomisedCardLoad
                                        title={'روی چک'}
                                        fileSelected={frontImage?.fileUrl}
                                        setChildValue={setFrontImage}
                                        fileArray={empthyFileArray}
                                        comment={frontImg[0]?.
                                            hints.length > 100 ? frontImg[0]?.
                                                hints.slice(0, 100) + '...' : frontImg[0]?.
                                            hints}
                                        checkBySetad={true}
                                        rejected={undefined}
                                        functionCheque={functionChequeFront}
                                        fileType={frontImage?.file ? frontImage?.file.type : frontImage?.fileType}
                                    />
                                ) :
                                    <>
                                        {frontImg[0] !== null && frontImg[0] !== undefined ? <CustomisedCardUpload
                                            title={'روی چک'}
                                            comment={frontImg[0]?.
                                                hints.length > 100 ? frontImg[0]?.
                                                    hints.slice(0, 100) + '...' : frontImg[0]?.
                                                hints}
                                            setFileSelected={setFrontImage}
                                            fileExtensions={frontImg[0]?.fileExtensions}
                                            maxSizeKb={frontImg[0]?.maxSizeKb}
                                        /> : null}
                                    </>
                                }
                            </div>
                            <div>
                                {rearImage?.fileUrl ? (
                                    <CustomisedCardLoad
                                        title={'پشت چک'}
                                        fileSelected={rearImage?.fileUrl}
                                        setChildValue={setRearImage}
                                        fileArray={empthyFileArray}
                                        comment={rearImg[0]?.
                                            hints.length > 100 ? rearImg[0]?.
                                                hints.slice(0, 100) + '...' : rearImg[0]?.
                                            hints}
                                        checkBySetad={true}
                                        rejected={undefined}
                                        functionCheque={functionCheque}
                                        fileType={rearImage?.file ? rearImage?.file.type : rearImage?.fileType}
                                    />
                                ) :
                                    <>
                                        {rearImg[0] !== null && rearImg[0] !== undefined ? <CustomisedCardUpload
                                            title={'پشت چک'}
                                            comment={rearImg[0]?.
                                                hints.length > 100 ? rearImg[0]?.
                                                    hints.slice(0, 100) + '...' : rearImg[0]?.
                                                hints}
                                            setFileSelected={setRearImage}
                                            fileExtensions={rearImg[0].fileExtensions}
                                            maxSizeKb={rearImg[0].maxSizeKb}
                                        /> : null}
                                    </>
                                }
                            </div>

                        </div>
                        <div className="py-5">
                            <CustomisedButton
                                title={'ثبت چک'}
                                disable={!(sayadNumber?.length === 16)}
                                onClick={handleCheque}
                                type="submit"
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
